import { PricingRule } from '@libs/schemas/src/pricing-rule';

export const formatScope = (scope: PricingRule['scope']) => {
  if (Object.keys(scope).length === 0) return 'Global';
  if (scope.customerClassification) return `Classification: ${scope.customerClassification}`;
  if (scope.zipCodes) return `${scope.zipCodes.length} zip codes`;
  if (scope.customerIds) return `${scope.customerIds.length} customers`;
  return 'No scope defined';
};
